import { service } from '../index.js';

const resource = process.env.VUE_APP_RESOURCE_SIRBPM_OPR;

export default {
  get(payload) {
    return service.post(resource, payload);
  }
};
